<template>
  <div v-if="object">
    <div class="row text-white" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{object.tsr.basis.name + ' - ' + object.tsr.ipr.client.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-input label="Дата установки"
                    v-model="object.executingDate"
                    :value="object.executingDate"
                    :date="true"
        ></base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <textarea rows="8" cols="10"
                  class="form-control"
                  placeholder="Комментарии к установке"
                  v-model="object.note">
        </textarea>
      </div>
    </div>

    <div v-if="deleteAllowed" class="row" style="padding-bottom: 15px">
      <div class="col-md-12" style="text-align: right">
        <base-button @click="kill" :size="'sm'" type="warning" fill>Удалить</base-button>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";
 import {userService} from "@/services/user.service";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false,
       deleteAllowed: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.$emit('update_top');
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     },
     async kill() {
       if (await this.$repo.killObject(this.object, 'kit')) {
         this.$emit('delete');
       }
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
     this.deleteAllowed = userService.isDeleteAllowed();
   }
 }
</script>
